module.exports = __webpack_public_path__ + "img/garde-corps inox.42b52757.jpg";